import './Loader.css';

interface LoaderProps {
    className?: string;
    label?: string;
    detail?: string;
    fullscreen?: boolean;
    compact?: boolean;
}

/** Shared with the first-paint loader in index.html. */
export function Loader({ className = '', label = 'Собираем маршрут', detail = 'Загружаем управление макетом', fullscreen = false, compact = false }: LoaderProps) {
    return (
        <div className={`rail-loader ${fullscreen ? 'rail-loader--fullscreen' : ''} ${compact ? 'rail-loader--compact' : ''} ${className}`} role="status" aria-live="polite">
            <span className="preload-kicker">л/м · локомотив</span>
            <div className="preload-mark" aria-hidden="true"><i /><i /><i /><i /><i /><i /></div>
            <p className="preload-title">{label}</p>
            <p className="preload-caption">{detail}</p>
            <span className="preload-line" aria-hidden="true" />
        </div>
    );
}
